/**
 * @generated SignedSource<<18452c4fecf9e78d472a971dd3302671>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ExamTypeEnum = "first_final" | "first_mid" | "second_final" | "second_mid" | "%future added value";
export type ExamYearEnum = "year_2020" | "year_2021" | "year_2022" | "year_2023" | "year_2024" | "year_2025" | "%future added value";
export type Ordering = "ASC" | "ASC_NULLS_FIRST" | "ASC_NULLS_LAST" | "DESC" | "DESC_NULLS_FIRST" | "DESC_NULLS_LAST" | "%future added value";
export type SchoolExamSourceStatusEnum = "published" | "scrap" | "upload_required" | "%future added value";
export type SchoolRegionEnum = "busan" | "chungbuk" | "chungnam" | "daegu" | "daejeon" | "gangwon" | "gwangju" | "gyeongbuk" | "gyeonggi" | "gyeongnam" | "incheon" | "jeju" | "jeongbuk" | "jeonnam" | "sejong" | "seoul" | "ulsan" | "%future added value";
export type SchoolYearEnum = "high_1" | "high_2" | "high_3" | "middle_1" | "middle_2" | "middle_3" | "%future added value";
export type SchoolExamSourceFilter = {
  AND?: SchoolExamSourceFilter | null;
  DISTINCT?: boolean | null;
  NOT?: SchoolExamSourceFilter | null;
  OR?: SchoolExamSourceFilter | null;
  assignedToId_Exact?: string | null;
  assignedToId_In?: ReadonlyArray<string> | null;
  assignedTo_Exists?: boolean | null;
  assignedTo_Exists_In?: ReadonlyArray<boolean> | null;
  completedById_In?: ReadonlyArray<string> | null;
  completedBy_Exists_In?: ReadonlyArray<boolean> | null;
  examType_In?: ReadonlyArray<ExamTypeEnum> | null;
  examYear_In?: ReadonlyArray<ExamYearEnum> | null;
  innerPdf_Exists_In?: ReadonlyArray<boolean> | null;
  pdf_Exists_In?: ReadonlyArray<boolean> | null;
  region_In?: ReadonlyArray<SchoolRegionEnum> | null;
  schoolId_In?: ReadonlyArray<string> | null;
  schoolId_Not_In?: ReadonlyArray<string> | null;
  schoolYear_In?: ReadonlyArray<SchoolYearEnum> | null;
  search?: string | null;
  status_In?: ReadonlyArray<SchoolExamSourceStatusEnum> | null;
};
export type SchoolExamSourceOrder = {
  completed?: Ordering | null;
  created?: Ordering | null;
  examYear?: Ordering | null;
  id?: Ordering | null;
  modified?: Ordering | null;
  school?: Ordering | null;
  school_Title?: Ordering | null;
};
export type SchoolExamScrapOrder = {
  created?: Ordering | null;
  id?: Ordering | null;
  modified?: Ordering | null;
  order?: Ordering | null;
};
export type SchoolExamSourcePaginatorRefreshQuery$variables = {
  after?: string | null;
  filters?: SchoolExamSourceFilter | null;
  first?: number | null;
  order?: SchoolExamSourceOrder | null;
  scrapCount?: number | null;
  scrapOrder?: SchoolExamScrapOrder | null;
};
export type SchoolExamSourcePaginatorRefreshQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SchoolExamSourcePaginator_query">;
};
export type SchoolExamSourcePaginatorRefreshQuery = {
  response: SchoolExamSourcePaginatorRefreshQuery$data;
  variables: SchoolExamSourcePaginatorRefreshQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "after"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filters"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "first"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "order"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "scrapCount"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "scrapOrder"
  }
],
v1 = {
  "kind": "Variable",
  "name": "after",
  "variableName": "after"
},
v2 = {
  "kind": "Variable",
  "name": "filters",
  "variableName": "filters"
},
v3 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "first"
},
v4 = {
  "kind": "Variable",
  "name": "order",
  "variableName": "order"
},
v5 = [
  (v1/*: any*/),
  (v2/*: any*/),
  (v3/*: any*/),
  (v4/*: any*/)
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SchoolExamSourcePaginatorRefreshQuery",
    "selections": [
      {
        "args": [
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "kind": "Variable",
            "name": "scrapCount",
            "variableName": "scrapCount"
          },
          {
            "kind": "Variable",
            "name": "scrapOrder",
            "variableName": "scrapOrder"
          }
        ],
        "kind": "FragmentSpread",
        "name": "SchoolExamSourcePaginator_query"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SchoolExamSourcePaginatorRefreshQuery",
    "selections": [
      {
        "alias": null,
        "args": (v5/*: any*/),
        "concreteType": "SchoolExamSourceConnection",
        "kind": "LinkedField",
        "name": "schoolExamSources",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "SchoolExamSourceEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "SchoolExamSource",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "sequence",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "School",
                    "kind": "LinkedField",
                    "name": "school",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      (v7/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "region",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v7/*: any*/),
                  {
                    "alias": null,
                    "args": [
                      {
                        "kind": "Variable",
                        "name": "first",
                        "variableName": "scrapCount"
                      },
                      {
                        "kind": "Variable",
                        "name": "order",
                        "variableName": "scrapOrder"
                      }
                    ],
                    "concreteType": "SchoolExamScrapConnection",
                    "kind": "LinkedField",
                    "name": "scraps",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "SchoolExamScrapEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "SchoolExamScrap",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v6/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "File",
                                "kind": "LinkedField",
                                "name": "scrap",
                                "plural": false,
                                "selections": [
                                  (v6/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "objectUrl",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v5/*: any*/),
        "filters": [
          "filters",
          "order"
        ],
        "handle": "connection",
        "key": "SchoolExamSourcePaginator_query_schoolExamSources",
        "kind": "LinkedHandle",
        "name": "schoolExamSources"
      }
    ]
  },
  "params": {
    "cacheID": "0fed01635c6d51e9b10d59d907da317f",
    "id": null,
    "metadata": {},
    "name": "SchoolExamSourcePaginatorRefreshQuery",
    "operationKind": "query",
    "text": "query SchoolExamSourcePaginatorRefreshQuery(\n  $after: String\n  $filters: SchoolExamSourceFilter\n  $first: Int\n  $order: SchoolExamSourceOrder\n  $scrapCount: Int\n  $scrapOrder: SchoolExamScrapOrder\n) {\n  ...SchoolExamSourcePaginator_query_2Y6WuD\n}\n\nfragment SchoolExamSourceExportedPreview_schoolExamSource_17JTyD on SchoolExamSource {\n  id\n  school {\n    id\n    title\n  }\n  title\n  scraps(order: $scrapOrder, first: $scrapCount) {\n    edges {\n      node {\n        id\n        scrap {\n          id\n          objectUrl\n        }\n      }\n    }\n  }\n}\n\nfragment SchoolExamSourcePaginator_query_2Y6WuD on Query {\n  schoolExamSources(filters: $filters, order: $order, first: $first, after: $after) {\n    totalCount\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n    edges {\n      cursor\n      node {\n        id\n        sequence\n        school {\n          id\n          title\n          region\n        }\n        title\n        scraps(order: $scrapOrder, first: $scrapCount) {\n          edges {\n            node {\n              id\n              scrap {\n                id\n                objectUrl\n              }\n            }\n          }\n        }\n        ...SchoolExamSourceExportedPreview_schoolExamSource_17JTyD\n        __typename\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "9625dfa4dd84696a8e0f371718fb5eab";

export default node;
